import React from 'react';
import PropTypes from 'prop-types';
// import classnames from 'classnames';

import { withUAPLThemedStyles } from '../with-themed-styles';
import { getStructuredSnippetExtensionStyles } from '../styles';

const StructuredSnippetExtension = ({
  classes,
  extensionData,
}) => (
  <div className={classes.structuredSnippetExtensionContainer}>
    {extensionData.map(({ Category, Texts }) => (
      <div className="structured-snippet-row">
        {Category && <span className="category">{`${Category}: `}</span>}
        {Texts && <span className="texts">{Texts.join(', ')}</span>}
      </div>
    ))}
  </div>
);

StructuredSnippetExtension.propTypes = {
  classes: PropTypes.shape({
    structuredSnippetExtensionContainer: PropTypes.string,
  }),
  extensionData: PropTypes.arrayOf(PropTypes.shape({
    Category: PropTypes.string,
    Texts: PropTypes.string,
  })),
};

StructuredSnippetExtension.defaultProps = {
  classes: {},
  extensionData: [],
};

export const AdPreviewStructuredSnippetExtension = withUAPLThemedStyles(
  StructuredSnippetExtension,
  getStructuredSnippetExtensionStyles, { componentName: 'AdPreviewStructuredSnippetExtension' }
);
